import script from "./workOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./workOrder.vue?vue&type=script&setup=true&lang=js"

import "./workOrder.vue?vue&type=style&index=0&id=570b40f4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-570b40f4"]])

export default __exports__